<template>
<ItpBox
  alignItems="center"
  class="items-spacing w-100"
  v-if="loaded"
>
  <ItpBox
    direction="column"
  >
    <ItpText
      muted
      :text="resourceTitle"
      class="mb-0"
      v-if="resourceTitle"
    >
    </ItpText>
    <ItpText
      tag="h5"
      :text="resourceKey"
      class="mb-0"
    >
    </ItpText>
  </ItpBox>
  <ItpBox
    direction="column"
    v-if="!entry.isNew && entry.invoice"
  >
    <ItpText
      muted
      :text="'Invoice number'|pgettext('RegisterEntryHeader')"
      class="mb-0"
    >
    </ItpText>
    <ItpText
      tag="h4"
      :text="entry.invoice.invoice_number"
      class="mb-0"
    >
    </ItpText>
  </ItpBox>
  <UcRegisterSelector
    :companyId="entry.version.company_id"
    v-model="registerInfo"
    toggleClass="bg-white"
    v-if="entry.isNew && selectRegister"
    @input="evh_8358196963355853_input($event, {})"
  >
  </UcRegisterSelector>
  <h6
    :title="'Locked'|pgettext('ResourceStatus')"
    class="my-0 align-self-center"
    v-if="entry.isReadOnly"
  >
    <span
      class="badge badge-secondary d-inline-flex align-items-center justify-content-start px-2"
      :style="b_6917646200545441_style"
    >
      <ItpIcon
        :icon="$config.lockIcon"
      >
      </ItpIcon>
      <span
        class="ml-1"
      >
        {{ 'Locked'|pgettext('ResourceStatus') }}
      </span>
    </span>
  </h6>
  <h6
    :title="'Void'|pgettext('ResourceStatus')"
    class="my-0 align-self-center"
    v-if="entry.void"
  >
    <span
      class="badge badge-warning d-inline-flex align-items-center justify-content-start px-2"
      :style="b_6424600534600827_style"
    >
      <ItpIcon
        icon="eva:slash-fill"
      >
      </ItpIcon>
      <span
        class="ml-1"
      >
        {{ 'Void'|pgettext('ResourceStatus') }}
      </span>
    </span>
  </h6>
  <b-button-group
    class="ml-auto"
  >
    <ItpButton
      icon="fa-sync-alt"
      :tooltip="'Reload'|gettext"
      :spinning="actions.reload.isRunning"
      variant="light"
      class="ml-auto"
      v-if="!entry.isNew"
      @click.prevent.stop="evh_4576710983066270_clickPreventStop($event, {})"
    >
    </ItpButton>
    <b-dropdown
      right
      variant="light"
      class="border"
      v-if="!entry.isNew"
    >
      <ItpIcon
        fa="bars"
        class="mx-1"
        slot="button-content"
      >
      </ItpIcon>
      <ItpButton
        dropdown-item
        :text="'Lock'|pgettext('BtnLockText')"
        :tooltip="'Lock'|pgettext('BtnLockTooltip')"
        variant="default"
        v-if="!entry.isNew && entry.meta.can_lock"
        @click.prevent.stop="evh_2124730035910225_clickPreventStop($event, {})"
      >
      </ItpButton>
      <ItpButton
        dropdown-item
        :text="'Unlock'|pgettext('BtnLockText')"
        :tooltip="'Unlock'|pgettext('BtnLockTooltip')"
        variant="default"
        v-if="!entry.isNew && entry.meta.can_unlock"
        @click.prevent.stop="evh_1972474632001399_clickPreventStop($event, {})"
      >
      </ItpButton>
      <ItpButton
        dropdown-item
        :text="'Invalidate'|pgettext('BtnLockText')"
        :tooltip="'Invalidate'|pgettext('BtnLockTooltip')"
        variant="default"
        v-if="!entry.isNew && entry.meta.can_invalidate"
        @click.prevent.stop="evh_2383909669375364_clickPreventStop($event, {})"
      >
      </ItpButton>
      <ItpButton
        dropdown-item
        :text="'Revoke invalidated'|pgettext('BtnLockText')"
        :tooltip="'Revoke invalidated'|pgettext('BtnLockTooltip')"
        variant="default"
        v-if="!entry.isNew && entry.meta.can_revoke_invalidation"
        @click.prevent.stop="evh_2342151935932928_clickPreventStop($event, {})"
      >
      </ItpButton>
      <BtnDeleteResource
        no-icon
        dropdown-item
        :resource="entry"
        :tooltip="'Delete entry'|pgettext('Register')"
        v-if="!entry.isNew && !entry.isReadOnly"
        @success="evh_2498310591257107_success($event, {})"
      >
      </BtnDeleteResource>
    </b-dropdown>
  </b-button-group>
</ItpBox>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcRegisterEntryHeader extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  entry!: object;

  @Watch('entry')
  onEntry(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("entry")
  }

  @Prop({
    type: Boolean,
  })
  selectRegister!: boolean;

  @Watch('selectRegister')
  onSelect_register(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("selectRegister")
  }

  messages!: any;
  registerInfo!: any;

  async $$load_registerInfo() {
    return {
      selectedRegisterId: this.entry.version.register_id,
      selectedVersionId: this.entry.version.version_id,
    }
  }

  ux!: any;
  b_6917646200545441_style!: any;
  b_6424600534600827_style!: any;
  dataMembers = ['messages', 'registerInfo', 'ux', 'b_6917646200545441_style', 'b_6424600534600827_style'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        messages: {
          newTransaction: this.$fn.pgettext("Register", "New entry"),
        }
        ,
        registerInfo: null,
        ux: null,
        b_6917646200545441_style: {
          "font-size": "1em",
        }
        ,
        b_6424600534600827_style: {
          "font-size": "1em",
        }
        ,
      },
    }
  }

  get resourceTitle() {
    if (this.loaded) {

      return !this.selectRegister && this.entry.version.name
    }
    return null;
  }

  get resourceKey() {
    if (this.loaded) {

      return this.entry.isNew
        ? this.messages.newTransaction + ` - ${this.entry.entry_number}`
        : this.entry.entry_number
    }
    return null;
  }

  async act_8358196963355853_script_8154_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_8358196963355853_script_8154, alias=undefined
    this.$emit('registerChanged', $event.data)
  }

  async act_8358196963355853_script_8154_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_8358196963355853_script_8154, alias=undefined
    return {
      value: () => this.act_8358196963355853_script_8154_getActionArgs_value($event),
    }
  }

  async evh_8358196963355853_input(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8358196963355853_input.executeFromDOM(this, event, scope);
  }

  async act_4576710983066270_emit_8156_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_4576710983066270_emit_8156, alias=reload
    return {
      event: "reload",
    }
  }

  async evh_4576710983066270_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4576710983066270_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_2124730035910225_emit_8160_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_2124730035910225_emit_8160, alias=undefined
    return {
      event: "reload",
    }
  }

  async act_2124730035910225_reloadSlickgrid_8162_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_2124730035910225_reloadSlickgrid_8162, alias=undefined
    return {
      grid: "register",
    }
  }

  async act_2124730035910225_request_8158_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_2124730035910225_request_8158, alias=lock
    return {
      operation: "update_register_entry",
      data: {
        id: this.entry.id,
        etag: this.entry.etag,
        locked: true,
      },
    }
  }

  async evh_2124730035910225_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2124730035910225_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_1972474632001399_emit_8166_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_1972474632001399_emit_8166, alias=undefined
    return {
      event: "reload",
    }
  }

  async act_1972474632001399_reloadSlickgrid_8168_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_1972474632001399_reloadSlickgrid_8168, alias=undefined
    return {
      grid: "register",
    }
  }

  async act_1972474632001399_request_8164_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_1972474632001399_request_8164, alias=lock
    return {
      operation: "update_register_entry",
      data: {
        id: this.entry.id,
        etag: this.entry.etag,
        locked: false,
      },
    }
  }

  async evh_1972474632001399_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1972474632001399_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_2383909669375364_emit_8172_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_2383909669375364_emit_8172, alias=undefined
    return {
      event: "reload",
    }
  }

  async act_2383909669375364_reloadSlickgrid_8174_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_2383909669375364_reloadSlickgrid_8174, alias=undefined
    return {
      grid: "register",
    }
  }

  async act_2383909669375364_request_8170_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_2383909669375364_request_8170, alias=lock
    return {
      operation: "update_register_entry",
      data: {
        id: this.entry.id,
        etag: this.entry.etag,
        void: true,
      },
    }
  }

  async evh_2383909669375364_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2383909669375364_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_2342151935932928_emit_8178_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_2342151935932928_emit_8178, alias=undefined
    return {
      event: "reload",
    }
  }

  async act_2342151935932928_reloadSlickgrid_8180_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_2342151935932928_reloadSlickgrid_8180, alias=undefined
    return {
      grid: "register",
    }
  }

  async act_2342151935932928_request_8176_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_2342151935932928_request_8176, alias=lock
    return {
      operation: "update_register_entry",
      data: {
        id: this.entry.id,
        etag: this.entry.etag,
        void: false,
      },
    }
  }

  async evh_2342151935932928_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2342151935932928_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_2498310591257107_emit_8182_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_2498310591257107_emit_8182, alias=undefined
    return {
      event: "deleted",
    }
  }

  async evh_2498310591257107_success(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2498310591257107_success.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_8358196963355853_script_8154: actions.ScriptAction;
    evh_8358196963355853_input_8153: actions.EventHandlerImpl;
    evh_8358196963355853_input: actions.EventHandlerGroup;
    act_4576710983066270_emit_8156: actions.EmitAction;
    evh_4576710983066270_clickPreventStop_8155: actions.EventHandlerImpl;
    evh_4576710983066270_clickPreventStop: actions.EventHandlerGroup;
    act_2124730035910225_emit_8160: actions.EmitAction;
    evh_2124730035910225_success_8159: actions.EventHandlerImpl;
    act_2124730035910225_reloadSlickgrid_8162: actions.ReloadSlickgridAction;
    evh_2124730035910225_success_8161: actions.EventHandlerImpl;
    act_2124730035910225_request_8158: actions.RequestAction;
    evh_2124730035910225_clickPreventStop_8157: actions.EventHandlerImpl;
    evh_2124730035910225_clickPreventStop: actions.EventHandlerGroup;
    act_1972474632001399_emit_8166: actions.EmitAction;
    evh_1972474632001399_success_8165: actions.EventHandlerImpl;
    act_1972474632001399_reloadSlickgrid_8168: actions.ReloadSlickgridAction;
    evh_1972474632001399_success_8167: actions.EventHandlerImpl;
    act_1972474632001399_request_8164: actions.RequestAction;
    evh_1972474632001399_clickPreventStop_8163: actions.EventHandlerImpl;
    evh_1972474632001399_clickPreventStop: actions.EventHandlerGroup;
    act_2383909669375364_emit_8172: actions.EmitAction;
    evh_2383909669375364_success_8171: actions.EventHandlerImpl;
    act_2383909669375364_reloadSlickgrid_8174: actions.ReloadSlickgridAction;
    evh_2383909669375364_success_8173: actions.EventHandlerImpl;
    act_2383909669375364_request_8170: actions.RequestAction;
    evh_2383909669375364_clickPreventStop_8169: actions.EventHandlerImpl;
    evh_2383909669375364_clickPreventStop: actions.EventHandlerGroup;
    act_2342151935932928_emit_8178: actions.EmitAction;
    evh_2342151935932928_success_8177: actions.EventHandlerImpl;
    act_2342151935932928_reloadSlickgrid_8180: actions.ReloadSlickgridAction;
    evh_2342151935932928_success_8179: actions.EventHandlerImpl;
    act_2342151935932928_request_8176: actions.RequestAction;
    evh_2342151935932928_clickPreventStop_8175: actions.EventHandlerImpl;
    evh_2342151935932928_clickPreventStop: actions.EventHandlerGroup;
    act_2498310591257107_emit_8182: actions.EmitAction;
    evh_2498310591257107_success_8181: actions.EventHandlerImpl;
    evh_2498310591257107_success: actions.EventHandlerGroup;
  }

  getActions() {
    const act_8358196963355853_script_8154 = new actions.ScriptAction(
      {
        actionArgs: this.act_8358196963355853_script_8154_getActionArgs,
        events: [],
      }
    );
    const evh_8358196963355853_input_8153 = new actions.EventHandlerImpl(
      {
        action: act_8358196963355853_script_8154,
        event: "input",
        displayName: "script",
      }
    );
    const evh_8358196963355853_input = new actions.EventHandlerGroup(
      {
        handlers: [evh_8358196963355853_input_8153],
      }
    );
    const act_4576710983066270_emit_8156 = new actions.EmitAction(
      {
        actionArgs: this.act_4576710983066270_emit_8156_getActionArgs,
        displayName: "reload",
        events: [],
      }
    );
    const evh_4576710983066270_clickPreventStop_8155 = new actions.EventHandlerImpl(
      {
        action: act_4576710983066270_emit_8156,
        event: "click.prevent.stop",
        displayName: "reload",
      }
    );
    const evh_4576710983066270_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_4576710983066270_clickPreventStop_8155],
      }
    );
    const act_2124730035910225_emit_8160 = new actions.EmitAction(
      {
        actionArgs: this.act_2124730035910225_emit_8160_getActionArgs,
        events: [],
      }
    );
    const evh_2124730035910225_success_8159 = new actions.EventHandlerImpl(
      {
        action: act_2124730035910225_emit_8160,
        event: "success",
        displayName: "emit",
      }
    );
    const act_2124730035910225_reloadSlickgrid_8162 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_2124730035910225_reloadSlickgrid_8162_getActionArgs,
        events: [],
      }
    );
    const evh_2124730035910225_success_8161 = new actions.EventHandlerImpl(
      {
        action: act_2124730035910225_reloadSlickgrid_8162,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_2124730035910225_request_8158 = new actions.RequestAction(
      {
        actionArgs: this.act_2124730035910225_request_8158_getActionArgs,
        displayName: "lock",
        events: [evh_2124730035910225_success_8159, evh_2124730035910225_success_8161],
      }
    );
    const evh_2124730035910225_clickPreventStop_8157 = new actions.EventHandlerImpl(
      {
        action: act_2124730035910225_request_8158,
        event: "click.prevent.stop",
        displayName: "lock",
      }
    );
    const evh_2124730035910225_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_2124730035910225_clickPreventStop_8157],
      }
    );
    const act_1972474632001399_emit_8166 = new actions.EmitAction(
      {
        actionArgs: this.act_1972474632001399_emit_8166_getActionArgs,
        events: [],
      }
    );
    const evh_1972474632001399_success_8165 = new actions.EventHandlerImpl(
      {
        action: act_1972474632001399_emit_8166,
        event: "success",
        displayName: "emit",
      }
    );
    const act_1972474632001399_reloadSlickgrid_8168 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_1972474632001399_reloadSlickgrid_8168_getActionArgs,
        events: [],
      }
    );
    const evh_1972474632001399_success_8167 = new actions.EventHandlerImpl(
      {
        action: act_1972474632001399_reloadSlickgrid_8168,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_1972474632001399_request_8164 = new actions.RequestAction(
      {
        actionArgs: this.act_1972474632001399_request_8164_getActionArgs,
        displayName: "lock",
        events: [evh_1972474632001399_success_8165, evh_1972474632001399_success_8167],
      }
    );
    const evh_1972474632001399_clickPreventStop_8163 = new actions.EventHandlerImpl(
      {
        action: act_1972474632001399_request_8164,
        event: "click.prevent.stop",
        displayName: "lock",
      }
    );
    const evh_1972474632001399_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1972474632001399_clickPreventStop_8163],
      }
    );
    const act_2383909669375364_emit_8172 = new actions.EmitAction(
      {
        actionArgs: this.act_2383909669375364_emit_8172_getActionArgs,
        events: [],
      }
    );
    const evh_2383909669375364_success_8171 = new actions.EventHandlerImpl(
      {
        action: act_2383909669375364_emit_8172,
        event: "success",
        displayName: "emit",
      }
    );
    const act_2383909669375364_reloadSlickgrid_8174 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_2383909669375364_reloadSlickgrid_8174_getActionArgs,
        events: [],
      }
    );
    const evh_2383909669375364_success_8173 = new actions.EventHandlerImpl(
      {
        action: act_2383909669375364_reloadSlickgrid_8174,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_2383909669375364_request_8170 = new actions.RequestAction(
      {
        actionArgs: this.act_2383909669375364_request_8170_getActionArgs,
        displayName: "lock",
        events: [evh_2383909669375364_success_8171, evh_2383909669375364_success_8173],
      }
    );
    const evh_2383909669375364_clickPreventStop_8169 = new actions.EventHandlerImpl(
      {
        action: act_2383909669375364_request_8170,
        event: "click.prevent.stop",
        displayName: "lock",
      }
    );
    const evh_2383909669375364_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_2383909669375364_clickPreventStop_8169],
      }
    );
    const act_2342151935932928_emit_8178 = new actions.EmitAction(
      {
        actionArgs: this.act_2342151935932928_emit_8178_getActionArgs,
        events: [],
      }
    );
    const evh_2342151935932928_success_8177 = new actions.EventHandlerImpl(
      {
        action: act_2342151935932928_emit_8178,
        event: "success",
        displayName: "emit",
      }
    );
    const act_2342151935932928_reloadSlickgrid_8180 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_2342151935932928_reloadSlickgrid_8180_getActionArgs,
        events: [],
      }
    );
    const evh_2342151935932928_success_8179 = new actions.EventHandlerImpl(
      {
        action: act_2342151935932928_reloadSlickgrid_8180,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_2342151935932928_request_8176 = new actions.RequestAction(
      {
        actionArgs: this.act_2342151935932928_request_8176_getActionArgs,
        displayName: "lock",
        events: [evh_2342151935932928_success_8177, evh_2342151935932928_success_8179],
      }
    );
    const evh_2342151935932928_clickPreventStop_8175 = new actions.EventHandlerImpl(
      {
        action: act_2342151935932928_request_8176,
        event: "click.prevent.stop",
        displayName: "lock",
      }
    );
    const evh_2342151935932928_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_2342151935932928_clickPreventStop_8175],
      }
    );
    const act_2498310591257107_emit_8182 = new actions.EmitAction(
      {
        actionArgs: this.act_2498310591257107_emit_8182_getActionArgs,
        events: [],
      }
    );
    const evh_2498310591257107_success_8181 = new actions.EventHandlerImpl(
      {
        action: act_2498310591257107_emit_8182,
        event: "success",
        displayName: "emit",
      }
    );
    const evh_2498310591257107_success = new actions.EventHandlerGroup(
      {
        handlers: [evh_2498310591257107_success_8181],
      }
    );
    return {
      act_8358196963355853_script_8154,
      evh_8358196963355853_input_8153,
      evh_8358196963355853_input,
      act_4576710983066270_emit_8156,
      evh_4576710983066270_clickPreventStop_8155,
      evh_4576710983066270_clickPreventStop,
      act_2124730035910225_emit_8160,
      evh_2124730035910225_success_8159,
      act_2124730035910225_reloadSlickgrid_8162,
      evh_2124730035910225_success_8161,
      act_2124730035910225_request_8158,
      evh_2124730035910225_clickPreventStop_8157,
      evh_2124730035910225_clickPreventStop,
      act_1972474632001399_emit_8166,
      evh_1972474632001399_success_8165,
      act_1972474632001399_reloadSlickgrid_8168,
      evh_1972474632001399_success_8167,
      act_1972474632001399_request_8164,
      evh_1972474632001399_clickPreventStop_8163,
      evh_1972474632001399_clickPreventStop,
      act_2383909669375364_emit_8172,
      evh_2383909669375364_success_8171,
      act_2383909669375364_reloadSlickgrid_8174,
      evh_2383909669375364_success_8173,
      act_2383909669375364_request_8170,
      evh_2383909669375364_clickPreventStop_8169,
      evh_2383909669375364_clickPreventStop,
      act_2342151935932928_emit_8178,
      evh_2342151935932928_success_8177,
      act_2342151935932928_reloadSlickgrid_8180,
      evh_2342151935932928_success_8179,
      act_2342151935932928_request_8176,
      evh_2342151935932928_clickPreventStop_8175,
      evh_2342151935932928_clickPreventStop,
      act_2498310591257107_emit_8182,
      evh_2498310591257107_success_8181,
      evh_2498310591257107_success,
      reload: act_4576710983066270_emit_8156,
      lock: act_2342151935932928_request_8176,
    }
  }
}

Vue.component("UcRegisterEntryHeader", UcRegisterEntryHeader);

</script>